import React from 'react';
import { useStoreMap } from 'effector-react';
import { $tourData, $tourDataApi } from '@stores/dataStores';
import StartAnimeBase from './StartAnimeBase';

function PanelStartAnime() {
  const startAnime = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.startAnime,
  });
  return (
    <StartAnimeBase
      defaultValue={startAnime}
      onConfirm={(val) => {
        $tourDataApi.update((draft) => {
          draft.startAnime = val;
        });
      }}
    />
  );
}

export default PanelStartAnime;
